import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TOURN_COLUMN_ID } from '../../types/MTT';
import type { TableColumn } from '../../types/MTT';
import { rowStateTimeComparator } from '../../utils/MTT/tournaments';

import TableCell from './TableCell/TableCell';
import TableCellBuyIn from './TableCell/TableCellBuyIn';
import TableCellPlayers from './TableCell/TableCellPlayers';
import TableCellState from './TableCell/TableCellState';
import {
  TXTCLI_Buy_In,
  TXTCLI_Game,
  TXTCLI_Name_thing,
  TXTCLI_Players,
  TXTCLI_Prize_Pool,
  TXTCLI_Start_State
} from './columnsConfig.messages.json';
import styles from './shared.scss';

export const DEFAULT_COLUMN = { width: undefined };

export const CELL_NAME: TableColumn = {
  Header: <Translation {...TXTCLI_Name_thing} />,
  accessor: TOURN_COLUMN_ID.formattedName,
  display: 'inline',
  cellStyles: styles.cellName,
  Cell: TableCell,
  renderValueAccessor: TOURN_COLUMN_ID.formattedName,
  cellExpand: true
};

export const CELL_GAME: TableColumn = {
  Header: <Translation {...TXTCLI_Game} />,
  accessor: TOURN_COLUMN_ID.formattedGame,
  Cell: TableCell,
  width: 115,
  renderValueAccessor: TOURN_COLUMN_ID.formattedGame
};

export const CELL_START_STATE: TableColumn = {
  Header: <Translation {...TXTCLI_Start_State} />,
  accessor: TOURN_COLUMN_ID.whenStart,
  sortType: rowStateTimeComparator,
  width: 145,
  lateRegStyle: styles.cellStartStateLateReg,
  Cell: TableCellState,
  renderValueAccessor: 'whenStart'
};

export const CELL_BUY_IN: TableColumn = {
  Header: <Translation {...TXTCLI_Buy_In} />,
  accessor: TOURN_COLUMN_ID.buyIn,
  width: 80,
  Cell: TableCellBuyIn
};

export const CELL_PRIZE_POOL: TableColumn = {
  Header: <Translation {...TXTCLI_Prize_Pool} />,
  accessor: TOURN_COLUMN_ID.prizePool,
  width: 120,
  cellStyles: styles.cellPrizePool,
  Cell: TableCell,
  renderValueAccessor: 'shortPrizePool'
};

export const CELL_PLAYERS: TableColumn = {
  Header: <Translation {...TXTCLI_Players} />,
  accessor: TOURN_COLUMN_ID.entrants,
  width: 80,
  Cell: TableCellPlayers
};

export const DEFAULT_SORT_COLUMN_ID = String(CELL_START_STATE?.accessor);
export const SEARCH_FILTER_COLUMN_ID = TOURN_COLUMN_ID.formattedName;
